import { IAbstractInitialState } from "../../types/common";
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import {
  getStaticPageById,
  getStaticPages,
} from "../../api/asyncThuncks/staticPages";
import { TStaticPages } from "../../types/staticPages";

interface IInitialState extends IAbstractInitialState {
  staticPages: TStaticPages[];
  staticPageById: TStaticPages;
  total: any;
}

const initialState: IInitialState = {
  loading: "idle",
  staticPages: [] as TStaticPages[],
  staticPageById: {} as TStaticPages,
  total: null,
  error: "",
};

const staticPage = createSlice({
  name: "staticPage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStaticPages.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(getStaticPages.fulfilled, (state, { payload }) => {
        state.staticPages = [...payload];
        state.loading = "idle";
      })
      .addCase(getStaticPages.rejected, (state, { error }) => {
        if (error.message) state.error = error.message;
        state.loading = "failed";
      })
      .addCase(getStaticPageById.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(getStaticPageById.fulfilled, (state, { payload }) => {
        state.loading = "idle";
        state.staticPageById = { ...payload };
      })
      .addCase(getStaticPageById.rejected, (state, { error }) => {
        if (error.message) state.error = error.message;
        state.loading = "failed";
      });
  },
});

export const selectStaticPage = (state: RootState): IInitialState =>
  state.staticPages;

export default staticPage.reducer;
